var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfilNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.334,
    height: 34.334,
    viewBox: "0 0 34.334 34.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #316094;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1983",
    "data-name": "Rect\\xE1ngulo 1983",
    className: "cls-1",
    width: 34.334,
    height: 34.334,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Perfil",
    "data-name": "Pictograma - Perfil",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3105",
    "data-name": "Grupo 3105",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4529",
    "data-name": "Trazado 4529",
    className: "cls-3",
    d: "M17.168,6.47a5.314,5.314,0,1,0,5.313,5.314A5.319,5.319,0,0,0,17.168,6.47m0,2.046A3.267,3.267,0,1,1,13.9,11.784a3.273,3.273,0,0,1,3.268-3.268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4530",
    "data-name": "Trazado 4530",
    className: "cls-3",
    d: "M17.169,34.335A17.167,17.167,0,1,1,34.335,17.166h0A17.185,17.185,0,0,1,17.169,34.333m0-31.943A14.776,14.776,0,1,0,31.946,17.167,14.775,14.775,0,0,0,17.169,2.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4531",
    "data-name": "Trazado 4531",
    className: "cls-3",
    d: "M17.168,27.9a14.582,14.582,0,0,1-9.194-3.433l-1.1-.889,1.105-.885a14.111,14.111,0,0,1,18.383,0l1.1.885-1.1.889a14.574,14.574,0,0,1-9.2,3.433M9.846,23.58a13.594,13.594,0,0,0,14.642,0,13.7,13.7,0,0,0-14.642,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilNormal);
export default __webpack_public_path__ + "static/media/perfilNormal.f07f25f43211259539695ba180b8f04b.svg";
export { ForwardRef as ReactComponent };